module.exports = __webpack_public_path__ + "img/financial-stability.0ca0203f.svg";